// extracted by mini-css-extract-plugin
export default {"root":"context-menu_root__ANQt+"};